import React from 'react';

const CustomizeIcon = ({ size, color }) => {
  return (
    <svg width={size ? size : '16'} height={size ? size : '17'} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8824 6.29412H9.23529M9.74695 2.21646L8 4.08822M5.94118 2.76471V1M3.88236 4.08824L2.13539 2.21649M2.64706 6.29412H1M3.88238 8.5L2.13541 10.3718M5.94118 11.5882V9.82353M15 16L8.41176 8.94118" stroke={color ? color : 'white'} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default CustomizeIcon;
